// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".full-answer[data-v-93621260]{margin-top:3em}@media (min-width:64em){.full-answer.full-answer--negative[data-v-93621260],.full-answer.full-answer--positive[data-v-93621260]{margin-top:6em}.full-answer.full-answer--neutral[data-v-93621260]{margin-top:5em}}", ""]);
// Exports
module.exports = exports;
